import {
  initialState,
  Actions,
  State,
  GET_ONE_CUSTOM_CONTENT_TYPE,
  GET_ONE_CUSTOM_CONTENT_TYPE_SUCCESS,
  GET_ONE_CUSTOM_CONTENT_TYPE_ERROR,
  RESET_GET_ONE_CUSTOM_CONTENT_TYPE,
} from '../../types/custom-content-tye/get-one'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ONE_CUSTOM_CONTENT_TYPE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ONE_CUSTOM_CONTENT_TYPE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ONE_CUSTOM_CONTENT_TYPE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ONE_CUSTOM_CONTENT_TYPE:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
